module.exports = __webpack_public_path__ + "img/historial_icon.8f558de2.svg";